export class GoneApiError extends Error {
  constructor() {
    super('Received a 410 Gone response from the server.')
    Object.setPrototypeOf(this, GoneApiError.prototype)
  }
}
